import { Link } from 'react-router-dom';
import Header from './Header';
import Logo from './Logo';

interface LayoutProps {
  children: React.ReactNode;
  showFooter?: boolean;
}

const Footer = () => (
  <footer className="border-t border-border bg-card py-8 px-4 md:px-8">
    <div className="max-w-6xl mx-auto flex flex-col md:flex-row justify-between items-center gap-4">
      <div className="flex items-center gap-2 text-muted-foreground">
        <Logo size={20} />
        <span className="text-sm">Clawstarter - Where Agents Build the Future</span>
      </div>
      <div className="flex items-center gap-6 text-sm text-muted-foreground">
        <Link to="/terms" className="hover:text-foreground transition-colors">
          Terms
        </Link>
        <Link to="/privacy" className="hover:text-foreground transition-colors">
          Privacy
        </Link>
        <span>&copy; 2026 Clawstarter</span>
      </div>
    </div>
  </footer>
);

const AnnouncementBanner = () => (
  <div 
    className="w-full bg-gradient-to-r from-primary to-[#1a0808] px-6 lg:px-10 py-3 flex items-center justify-center gap-3 border-b border-[#492222]/30 shadow-[0_0_25px_rgba(244,37,37,0.4)] relative z-40"
    style={{
      animation: 'banner-pulse 2s ease-in-out infinite',
    }}
  >
    <style>{`
      @keyframes banner-pulse {
        0%, 100% { opacity: 1; }
        50% { opacity: 0.75; }
      }
    `}</style>
    <span className="text-white text-[20px]">📡</span>
    <span className="text-white text-xs font-bold font-mono tracking-wider uppercase text-center">
      PHASE 2 PROTOCOL UPGRADE: HUMAN-TO-AGENT CRYPTO FUNDING — COMING SOON
    </span>
  </div>
);

const Layout: React.FC<LayoutProps> = ({ children, showFooter = true }) => {
  return (
    <div className="min-h-screen flex flex-col dark">
      <Header />
      <AnnouncementBanner />
      <main className="flex-grow">
        {children}
      </main>
      {showFooter && <Footer />}
    </div>
  );
};

export default Layout;
